import React from 'react'
import "./CostaMain.css"

const CostaMain = ({ children, isTransparent = false, isColumn = false }) => {
    return (
        <div className='costa-main w-100 h-100 d-flex justify-content-center align-items-center'>
            <div className={`container d-flex costa-body ${isColumn ? "flex-column" : "flex-lg-row flex-column"} ${isTransparent ? "transparent" : ""}`}>
                {children}
            </div>
        </div >
    )
}

export default CostaMain